import FileContainer from './file-container';

export default FileContainer;